<template>
  <div class="wrapper">
    <div class="loader" />
    {{ $t("data_loading") }}
  </div>
</template>

<script>
export default {
  name: "Spinner",
}
</script>

<style scoped lang="scss">
.wrapper {
  font-size: 0.75rem;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  padding: 1rem;
  margin: auto;
}

.loader,
.loader::after {
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
}

.loader {
  font-size: 0.5rem;
  border: 0.5rem solid rgba(#000, 0.5);
  border-left: 0.5rem solid $primary;
  margin: 0 auto 0.5rem;
  position: relative;
  transform: translateZ(0);
  animation: spin 1.1s infinite linear;
}
</style>
